import React, { useEffect, useState } from 'react';
import { BsInstagram } from 'react-icons/bs';
import { BsTwitterX } from 'react-icons/bs';

import { FaLinkedinIn, FaFacebookF, FaYoutube } from 'react-icons/fa';
import data from '../../data/data';
import settings from '../../data/settings';

const SocialNetworks = (props) => {
  const [isTwitterHovered, setIsTwitterHovered] = useState(false);
  const [isLinkedinHovered, setIsLinkedinHovered] = useState(false);
  const [isInstagramHovered, setIsInstagramHovered] = useState(false);
  const [isFacebookHovered, setIsFacebookHovered] = useState(false);
  const [isYoutubeHovered, setIsYoutubeHovered] = useState(false);
  const [isSocialMediaLabelHovered, setIsSocialMediaLabelHovered] =
    useState(false);

  const [socialNetworks, setSocialNetworks] = useState([]);
  const [socialNetworksLabel, setSocialNetworksLabel] = useState('');
  const [singleSocialNetwork, setSingleSocialNetwork] = useState(null);

  const [iconColor, setIconColor] = useState(null);
  const [hoverIconColor, setHoverIconColor] = useState(null);

  const iconColorStyle = {
    color: iconColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  const hoverIconStyle = {
    color: hoverIconColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  useEffect(() => {
    setSocialNetworksLabel(data.social_network_label);
    setIconColor(settings.colors.social_media_icons_color);
    setHoverIconColor(settings.colors.social_media_icons_color_hover);
    setSocialNetworks(data.social_networks);
    const urls = Object.values(data.social_networks).filter((url) => url);
    if (urls.length === 1) {
      // Postoji tačno jedna društvena mreža, postavi URL
      setSingleSocialNetwork(urls[0]);
    } else {
      // Postoji više ili nijedna društvena mreža, postavi na null
      setSingleSocialNetwork(null);
    }
  }, [data.social_networks, data.social_network_label, settings.colors]);

  return (
    <div
      className='socialNetworksWrapper'
      style={{ display: 'flex', flexDirection: 'row' }}
    >
      <div className='text-[18px] text-darkFontColor d-flex flex-row justify-center self-center ml-8'>
        <a
          className='social-networks-label font-extrabold text-[18px] text-darkFontColor mr-3'
          href={singleSocialNetwork ? singleSocialNetwork : undefined}
          target='_blank'
          rel='noopener noreferrer'
          onMouseEnter={() => setIsSocialMediaLabelHovered(true)}
          onMouseLeave={() => setIsSocialMediaLabelHovered(false)}
        >
          {socialNetworksLabel}
        </a>
      </div>
      <div className='flex flex-row flex-center mr-8 py-8 gap-3 text-xl'>
        <div
          style={{
            display: `${data.social_networks.twitter_url ? 'flex' : 'none'}`,
          }}
        >
          <a
            href={data.social_networks.twitter_url}
            style={isTwitterHovered ? hoverIconStyle : iconColorStyle}
            onMouseEnter={() => setIsTwitterHovered(true)}
            onMouseLeave={() => setIsTwitterHovered(false)}
            target='_blank'
            rel='noopener noreferrer'
          >
            <BsTwitterX className='social-media-icon social-media-icon-twitter' />
          </a>
        </div>
        <div
          style={{
            display: `${data.social_networks.linkedin_url ? 'flex' : 'none'}`,
          }}
        >
          <a
            href={data.social_networks.linkedin_url}
            style={isLinkedinHovered ? hoverIconStyle : iconColorStyle}
            onMouseEnter={() => setIsLinkedinHovered(true)}
            onMouseLeave={() => setIsLinkedinHovered(false)}
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaLinkedinIn className='social-media-icon social-media-icon-linkedin' />
          </a>
        </div>
        <div
          style={{
            display: `${data.social_networks.instagram_url ? 'flex' : 'none'}`,
          }}
        >
          <a
            href={data.social_networks.instagram_url}
            style={isInstagramHovered ? hoverIconStyle : iconColorStyle}
            onMouseEnter={() => setIsInstagramHovered(true)}
            onMouseLeave={() => setIsInstagramHovered(false)}
            target='_blank'
            rel='noopener noreferrer'
          >
            <BsInstagram className='social-media-icon social-media-icon-instagram' />
          </a>
        </div>
        <div
          style={{
            display: `${data.social_networks.facebook_url ? 'flex' : 'none'}`,
          }}
        >
          <a
            href={data.social_networks.facebook_url}
            style={isFacebookHovered ? hoverIconStyle : iconColorStyle}
            onMouseEnter={() => setIsFacebookHovered(true)}
            onMouseLeave={() => setIsFacebookHovered(false)}
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaFacebookF className='social-media-icon social-media-icon-facebook' />
          </a>
        </div>
        <div
          style={{
            display: `${data.social_networks.youtube_url ? 'flex' : 'none'}`,
          }}
        >
          <a
            href={data.social_networks.youtube_url}
            style={isYoutubeHovered ? hoverIconStyle : iconColorStyle}
            onMouseEnter={() => setIsYoutubeHovered(true)}
            onMouseLeave={() => setIsYoutubeHovered(false)}
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaYoutube className='social-media-icon social-media-icon-youtube' />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SocialNetworks;
// <p className='social-networks-label font-extrabold'>
//   {socialNetworksLabel}
// </p>
